<script setup lang="ts">
const emit = defineEmits(['close'])
</script>

<template>
  <div
    class="fixed right-0 bottom-0 left-0 p-4 bg-white border-t border-gray-200"
  >
    <div class="max-w-sm mx-auto flex items-center justify-between">
      <ClickToCall v-slot="{ handleClick }">
        <a
          :href="phone.uri"
          @click="handleClick"
          class="block p-2 bg-darkBlue rounded-md"
        >
          <Icon i-heroicons-solid:phone class="w-5 h-5 text-white" />
        </a>
      </ClickToCall>
      <ClickToCall v-slot="{ handleClick }">
        <a
          :href="phone.uri"
          @click="handleClick"
          class="text-lg text-darkBlue font-medium"
        >
          {{ phone.formatted }} (TTY 711)
        </a>
      </ClickToCall>
      <button @click="emit('close')">
        <Icon i-heroicons-solid:x class="w-5 h-5 text-darkBlue" />
      </button>
    </div>
  </div>
</template>
